export default {"src":"/_next/static/media/Legendary-badge.0973d90f.svg","height":68,"width":68};